/**
 * Created by liwenqiang on 2018/3/22.
 */
const $ = require('jquery');

module.exports = function() {
    const footerHeight = $('.footer').height();
    const screenHeight = $(document).height();

    $('body > .content').css('minHeight', screenHeight - footerHeight);
}


//////////////////
// WEBPACK FOOTER
// ./src/global/js/content-min-height.js
// module id = 8
// module chunks = 0 1 2